module.exports = __webpack_public_path__ + "static/img/1805_7.fb4fa50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1805_7.jpg
// module id = YsEh
// module chunks = 1